if(_SCLayoutDetail === undefined) {

    function SCLayoutDetail() {
        this.vendors = []
    }
    var _SCLayoutDetail = {
        emit: function (name) {
            console.log("%c→ EMIT SCLayoutDetail." + name,"background:#1e98ec;color:#FFF")
            console.log({arguments})
            $(document).trigger('SCLayoutDetail.' + name, arguments);
        },
        _init: SCLayoutProducts.prototype.init,
        init: function () {
            this._init();
        }
    }

    //heritage de detail
    SCLayoutDetail.prototype = _.merge(SCLayoutProducts.prototype, _SCLayoutDetail);
    console.log("%cRENDER SC.layout-detail.js","background:yellow;color:#333")
}